import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private readonly http = inject(HttpClient);
  apiUrl = environment.apiUrl
  constructor() { }

  deleteShift(shiftId: number) {
    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/cancel`, '').pipe(
      catchError(error => {
        // Handle error here, e.g., log it or transform it
        console.error('Delete assignment failed', error);
        // Pass the error to the subscriber
        return throwError(() => error);
      })
    );
  }

  rateAndCommentToGuard(payload: any) {
    const { shiftId, ...body } = payload; // remove shiftId from body
    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/guard-rates`, body).pipe(
      catchError(error => {
        console.error('Rate guard failed', error);
        return throwError(() => error);
      })
    );
  }

  blockedUser(shiftId, guardId) {
    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/cancel-guard-from-customer`, { guardId: guardId }).pipe(
      catchError(error => {
        console.error('Rate guard failed', error);
        return throwError(() => error);
      })
    )
  }

  registeredUser(registeredData) {
    return this.http.post(`${this.apiUrl}/auth/employees/employee-register`, registeredData)
      .pipe(
        catchError(error => {
          console.error('Rate guard failed', error);
          return throwError(() => error);
        })
      );
  }


  getShiftDetailsById(custId, shiftId) {
    return this.http.get(`${this.apiUrl}/customers/${custId}/shifts/${shiftId}`).pipe(
      catchError(error => {
        // Handle error here, e.g., log it or transform it
        console.error('Delete assignment failed', error);
        // Pass the error to the subscriber
        return throwError(() => error);
      })
    );
  }

  acceptGuardForShift(shiftId: number, guardId: number) {
    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/accept`, {
      guardIds: [String(guardId)]
    }).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  approveOvertime(shiftId: number, guardId: number, checkinTime?: string, checkoutTime?: string) {
    const payload: any = {
      "guardId": [guardId],
      "status": 301
    };

    if (checkinTime) {
      payload.correctedCheckinTime = checkinTime;
    }
    if (checkoutTime) {
      payload.correctedCheckoutTime = checkoutTime;
    }

    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/approve-hours`, payload).pipe(
      catchError(error => {
        console.error('Approve time report failed', error);
        return throwError(() => error);
      })
    );
  }

  rejectOvertime(shiftId: number, guardId: number, checkinTime?: string, checkoutTime?: string) {
    const payload: any = {
      "guardId": [guardId],
      "status": 302
    };

    if (checkinTime) {
      payload.correctedCheckinTime = checkinTime;
    }
    if (checkoutTime) {
      payload.correctedCheckoutTime = checkoutTime;
    }

    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/approve-hours`, payload).pipe(
      catchError(error => {
        console.error('Reject time report failed', error);
        return throwError(() => error);
      })
    );
  }

  correctTimeReport(shiftId: number, guardId: number, checkinTime: string, checkoutTime: string, status: number = 301) {
    return this.http.post(`${this.apiUrl}/shifts/${shiftId}/approve-hours`, {
      "guardId": [guardId],
      "correctedCheckinTime": checkinTime,
      "correctedCheckoutTime": checkoutTime,
      "status": status
    }).pipe(
      catchError(error => {
        console.error('Correct time report failed', error);
        return throwError(() => error);
      })
    );
  }
}